import './SourceBadge.scss';

type DataSource = 'DB' | 'RECURLY' | 'LMS' | 'YOUTUBE' | 'GA4' | 'SALESFORCE';

interface SourceBadgeProps {
  source: DataSource;
}

const sourceConfig: Record<DataSource, { label: string; backgroundColor: string; labelColor: string }> = {
  DB: { label: 'DB', backgroundColor: 'var(--source-db, rgba(79, 70, 229, 0.1))', labelColor: 'var(--source-db-label, rgb(79, 70, 229))' },
  RECURLY: {
    label: 'RECURLY',
    backgroundColor: 'var(--source-recurly, rgba(194, 65, 12, 0.1))',
    labelColor: 'var(--source-recurly-label, #c2410c)',
  },
  LMS: { label: 'LMS', backgroundColor: 'var(--source-lms, rgba(109, 40, 217, 0.1))', labelColor: 'var(--source-lms-label, #6d28d9)' },
  YOUTUBE: {
    label: 'YOUTUBE',
    backgroundColor: 'var(--source-youtube, rgba(220, 38, 28, 0.1))',
    labelColor: 'var(--source-youtube-label, #dc2626)',
  },
  GA4: { label: 'GA4', backgroundColor: 'var(--source-ga4, rgba(22, 101, 52, 0.1))', labelColor: 'var(--source-ga4-label, #166534)' },
  SALESFORCE: {
    label: 'SALESFORCE',
    backgroundColor: 'var(--source-salesforce, rgba(29, 78, 216, 0.1))',
    labelColor: 'var(--source-salesforce-label, #1d4ed8)',
  },
};

export const SourceBadge = ({ source }: SourceBadgeProps) => {
  const config = sourceConfig[source];
  return (
    <div className='source-badge' style={{ backgroundColor: config.backgroundColor, color: config.labelColor }}>
      {config.label}
    </div>
  );
};

export default SourceBadge;
